import React from "react";
import { motion } from "framer-motion";
import { Card } from "../../ui";

const colorMap = {
  blue: "from-blue-50 to-blue-100 border-blue-500 text-blue-600",
  red: "from-red-50 to-red-100 border-red-500 text-red-600",
  orange: "from-orange-50 to-orange-100 border-orange-500 text-orange-600",
  yellow: "from-yellow-50 to-yellow-100 border-yellow-500 text-yellow-600",
  green: "from-green-50 to-green-100 border-green-500 text-green-600",
  purple: "from-purple-50 to-purple-100 border-purple-500 text-purple-600",
  gray: "from-gray-50 to-gray-100 border-gray-400 text-gray-600",
};

const AnimatedCard = motion(Card);

const VaptSummaryCard = ({ label, value, icon: Icon, color = "blue", subtext, delay = 0, onClick }) => {
  const cls = colorMap[color] || colorMap.blue;
  const [, , border, text] = cls.split(" ");

  return (
    <AnimatedCard
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={`border-l-4 ${border} ${onClick ? "cursor-pointer hover:shadow-md transition-shadow" : ""}`}
    >
      <div className="flex items-center justify-between mb-2">
        {Icon && <Icon className={`w-5 h-5 ${text}`} />}
      </div>
      <p className="text-xs font-medium text-gray-600">{label}</p>
      <p className={`text-2xl font-bold ${text}`}>{value ?? 0}</p>
      {subtext && <p className="text-[11px] text-gray-500 mt-1">{subtext}</p>}
    </AnimatedCard>
  );
};

export default VaptSummaryCard;
